/* Luvlyn · de handleiding (/pages/handleiding; ontwerp: handleiding.html en js/handleiding.js).
   Alleen wat deze pagina extra doet. Het geluid (data-geluid) en het binnenkomen doen assets/site.js en
   assets/beweging.js. Alle tekst staat in de HTML (de instellingen van de secties); dit script toont en
   verbergt alleen.
   1. "Print deze handleiding": window.print(). Vóór het printen gaan uitklappers open, erna weer dicht;
      wat er geprint wordt, regelt @media print in assets/hl.css.
   2. De kop: grotere letters. De keuze blijft in deze browser (localStorage) en staat als
      data-hl-letters op <html>.
   3. Instellen: stap voor stap (knoppen, vegen, pijltjestoetsen). Zonder script is het een rij om te vegen.
   4. Welke knop doet wat: tabbladen; de foto wisselt mee.
   5. Werkt hij niet: kies wat je merkt, de oplossing verschijnt. Zonder script staan ze er allemaal.
   6. De ringen op de foto's pulsen één keer als de foto in beeld komt of gekozen wordt, niet eindeloos
      (WCAG 2.2.2, review 04-10). Bij minder beweging niet. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const zacht = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gedrag = zacht ? 'instant' : 'smooth';   // niet 'auto': html heeft scroll-behavior:smooth
  // de ringen in een foto (opnieuw) laten pulsen: .puls weghalen, reflow, terugzetten
  const puls = el => { if (el && !zacht) $$('.hl-ring', el).forEach(r => { r.classList.remove('puls'); void r.offsetWidth; r.classList.add('puls'); }); };

  /* ---------- 1. printen ---------- */
  document.addEventListener('click', e => { if (e.target.closest('[data-print]')) window.print(); });
  // bijhouden wat dicht was, ook als beforeprint twee keer komt (dan staat alles al open)
  let dichtVoorPrint = [];
  addEventListener('beforeprint', () => {
    const dicht = $$('details:not([open])');
    dichtVoorPrint = [...new Set([...dichtVoorPrint, ...dicht])];
    dicht.forEach(d => { d.open = true; });
  });
  addEventListener('afterprint', () => { dichtVoorPrint.forEach(d => { d.open = false; }); dichtVoorPrint = []; });

  /* ---------- 2. grotere letters ---------- */
  const SLEUTEL = 'luvlyn-handleiding-letters';
  const letterKnoppen = $$('[data-hl-letters]');
  let letters = 'normaal';
  try { letters = localStorage.getItem(SLEUTEL) || 'normaal'; } catch {}
  function pasLettersToe(){
    const stand = letterKnoppen.length ? letters : 'normaal';
    if (stand === 'normaal') delete document.documentElement.dataset.hlLetters;
    else document.documentElement.dataset.hlLetters = stand;
    letterKnoppen.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hlLetters === letters)));
  }
  letterKnoppen.forEach(b => b.addEventListener('click', () => {
    letters = b.dataset.hlLetters;
    try { localStorage.setItem(SLEUTEL, letters); } catch {}
    pasLettersToe();
  }));
  pasLettersToe();

  /* ---------- 3. instellen: stap voor stap ---------- */
  $$('[data-hl-stapper]').forEach(box => {
    const rij = $('[data-hl-rij]', box), stappen = [...rij.children];
    const vorige = $('[data-hl-vorige]', box), volgende = $('[data-hl-volgende]', box), tekst = $('[data-hl-volgende-tekst]', box);
    const nu = $('[data-hl-nu]', box), stippen = $$('.hl-st3-stippen i', box);
    if (!stappen.length || !vorige || !volgende) return;
    let i = 0;
    function zet(n){
      i = n;
      if (nu) nu.textContent = n + 1;
      stippen.forEach((s, k) => s.classList.toggle('aan', k === n));
      vorige.disabled = n === 0;
      if (tekst) tekst.textContent = n === stappen.length - 1 ? volgende.dataset.hlLaatste : volgende.dataset.hlTekst;
    }
    const naar = n => rij.scrollTo({ left: stappen[n].offsetLeft - stappen[0].offsetLeft, behavior: gedrag });
    vorige.addEventListener('click', () => naar(Math.max(0, i - 1)));
    volgende.addEventListener('click', () => {
      if (i === stappen.length - 1) {
        const doel = volgende.dataset.hlVerder && document.getElementById(volgende.dataset.hlVerder.slice(1));
        doel?.scrollIntoView({ block: 'start', behavior: gedrag });
        return;
      }
      naar(i + 1);
    });
    rij.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); naar(Math.min(stappen.length - 1, i + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); naar(Math.max(0, i - 1)); }
    });
    // welke stap staat er in beeld (ook na vegen): IntersectionObserver binnen de rij
    const io = new IntersectionObserver(items => items.forEach(it => { if (it.isIntersecting) zet(stappen.indexOf(it.target)); }), { root: rij, threshold: .6 });
    stappen.forEach(s => io.observe(s));
    zet(0);
  });

  /* ---------- 4. welke knop doet wat: tabbladen ---------- */
  $$('[data-hl-tabs]').forEach(box => {
    const tabs = $$('[role="tab"]', box), figs = $$('[data-hl-fig]', box), panelen = $$('[data-hl-paneel]', box);
    function kies(n, focus = false){
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === n)); t.tabIndex = k === n ? 0 : -1; });
      panelen.forEach((p, k) => { p.hidden = k !== n; });
      figs.forEach((f, k) => f.classList.toggle('aan', k === n));
      puls(figs[n]);
      if (focus) tabs[n].focus();
    }
    tabs.forEach((t, k) => {
      t.addEventListener('click', () => kies(k));
      t.addEventListener('keydown', e => {
        const stap = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (stap) { e.preventDefault(); kies((k + stap + tabs.length) % tabs.length, true); }
        if (e.key === 'Home') { e.preventDefault(); kies(0, true); }
        if (e.key === 'End') { e.preventDefault(); kies(tabs.length - 1, true); }
      });
    });
  });

  /* ---------- 5. werkt hij niet: kies wat je merkt ---------- */
  $$('[data-hl-keuze]').forEach(box => {
    const knoppen = $$('[data-hl-kies]', box), panelen = $$('[data-hl-oplossing]', box);
    if (!knoppen.length) return;
    box.classList.add('klaar');   // vanaf nu één oplossing tegelijk
    function kies(id){
      knoppen.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hlKies === id)));
      panelen.forEach(p => p.classList.toggle('aan', p.dataset.hlOplossing === id));
    }
    knoppen.forEach(b => b.addEventListener('click', () => {
      kies(b.dataset.hlKies);
      // op een telefoon staat de oplossing onder de knoppen: even laten zien
      if (matchMedia('(max-width:760px)').matches) $('.hl-oplossing.aan', box)?.scrollIntoView({ block: 'nearest', behavior: gedrag });
    }));
    kies(knoppen[0].dataset.hlKies);
  });

  /* ---------- 6. de ringen: één puls als de foto in beeld komt ----------
     De observer ziet ook een foto die in de rij van Instellen in beeld schuift, en een oplossing die van
     display:none komt. De gekozen knop bij Welke knop doet wat pulst via kies() hierboven. */
  if (!zacht && 'IntersectionObserver' in window) {
    const kijk = new IntersectionObserver(items => items.forEach(it => { if (it.isIntersecting) puls(it.target); }), { threshold: .6 });
    $$('.hl-doek, .hl-uitsnede').forEach(el => kijk.observe(el));
  }
})();
